import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-323edd54"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  "class": "ConversationSettings__container ConversationSettings__container--dark"
};
var _hoisted_2 = {
  "class": "ConversationSettings__icon-holder ConversationSettings__container--inverted",
  id: "walkthrough-speech-items"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Convo", -1);
});
var _hoisted_4 = {
  "class": /*#__PURE__*/_normalizeClass({
    'ConversationSettings__icon-label': true,
    'ConversationSettings__icon-label--inactive': false
  })
};
var _hoisted_5 = {
  "class": "ConversationSettings__icon-holder ConversationSettings__container--inverted"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Convo", -1);
});
var _hoisted_7 = {
  "class": /*#__PURE__*/_normalizeClass({
    'ConversationSettings__icon-label': true,
    'ConversationSettings__icon-label--inactive': false
  })
};
var _hoisted_8 = {
  "class": "ConversationSettings__icon-holder ConversationSettings__container--inverted"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Convo", -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, " Continuous", -1);
});
var _hoisted_11 = {
  "class": "ConversationSettings__icon-holder ConversationSettings__container--inverted"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Convo", -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, " Brilliance", -1);
});
var _hoisted_14 = {
  "class": "ConversationSettings__icon-holder ConversationSettings__icon-holder--larger ConversationSettings__container--inverted"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Memories ", -1);
});
var _hoisted_16 = {
  "class": "memoryCover__holder-left"
};
var _hoisted_17 = {
  "class": "memoryCover__left ConversationSettings__container--inverted"
};
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "memoryLabels"
  }, [/*#__PURE__*/_createElementVNode("span", {
    "class": "notActive"
  }, "Don't Use"), /*#__PURE__*/_createTextVNode(" but "), /*#__PURE__*/_createElementVNode("span", {
    "class": "active"
  }, "store")])], -1);
});
var _hoisted_19 = {
  "class": "ConversationSettings__icon-holder ConversationSettings__icon-holder--larger ConversationSettings__container--inverted"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Memories ", -1);
});
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "memoryLabels"
  }, [/*#__PURE__*/_createElementVNode("span", {
    "class": "active"
  }, "Use"), /*#__PURE__*/_createTextVNode(" and "), /*#__PURE__*/_createElementVNode("span", {
    "class": "active"
  }, "Store")])], -1);
});
var _hoisted_22 = {
  "class": "ConversationSettings__icon-holder ConversationSettings__icon-holder--larger ConversationSettings__container--inverted"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Memories ", -1);
});
var _hoisted_24 = {
  "class": "memoryCover__holder-right"
};
var _hoisted_25 = {
  "class": "memoryCover__right ConversationSettings__container--inverted"
};
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "memoryLabels"
  }, [/*#__PURE__*/_createElementVNode("span", {
    "class": "active"
  }, "Use"), /*#__PURE__*/_createTextVNode(" but "), /*#__PURE__*/_createElementVNode("span", {
    "class": "notActive"
  }, "Don't store")])], -1);
});
var _hoisted_27 = {
  "class": "ConversationSettings__icon-holder ConversationSettings__icon-holder--larger ConversationSettings__container--inverted"
};
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Memories ", -1);
});
var _hoisted_29 = {
  "class": "memoryCover__holder-left"
};
var _hoisted_30 = {
  "class": "memoryCover__left ConversationSettings__container--inverted"
};
var _hoisted_31 = {
  "class": "memoryCover__holder-right"
};
var _hoisted_32 = {
  "class": "memoryCover__right ConversationSettings__container--inverted"
};
var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': true,
      'ConversationSettings__icon--brain': true
    })
  }, "Off ", -1);
});
var _hoisted_34 = {
  "class": "ConversationSettings__icon-holder ConversationSettings__container--inverted"
};
var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Context ", -1);
});
var _hoisted_36 = {
  "class": "ConversationSettings__icon-holder ConversationSettings__container--inverted"
};
var _hoisted_37 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Responses ", -1);
});
var _hoisted_38 = {
  "class": /*#__PURE__*/_normalizeClass({
    'ConversationSettings__icon-label': true,
    'ConversationSettings__icon-label--inactive': false
  })
};
var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--above': true
    })
  }, "Assistance ", -1);
});
var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": /*#__PURE__*/_normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': false
    })
  }, " Support", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_WalkthroughPointer = _resolveComponent("WalkthroughPointer");
  return !_ctx.$store.state.showNotes && !_ctx.$store.state.showToDoList ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_font_awesome_icon, {
    icon: ['fa', 'keyboard'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true
    })
  }), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.returnVoiceTextLabel()), 1)], 512), [[_vShow, _ctx.$store.state.textOnlyMode]]), _withDirectives(_createElementVNode("div", _hoisted_5, [_hoisted_6, _ctx.$store.state.TutorialPointerConvo ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'microphone'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true
    }),
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.toggleTextVoice();
    })
  }), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.returnVoiceTextLabel()), 1)], 512), [[_vShow, !_ctx.$store.state.textOnlyMode && !_ctx.$store.state.continuousListenMode && !_ctx.$store.state.brillianceMode]]), _withDirectives(_createElementVNode("div", _hoisted_8, [_hoisted_9, _ctx.$store.state.TutorialPointerConvo ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'infinity'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true
    }),
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.toggleTextVoice();
    })
  }), _hoisted_10], 512), [[_vShow, !_ctx.$store.state.textOnlyMode && _ctx.$store.state.continuousListenMode && !_ctx.$store.state.brillianceMode]]), _withDirectives(_createElementVNode("div", _hoisted_11, [_hoisted_12, _ctx.$store.state.TutorialPointerConvo ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'brain-circuit'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true
    }),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.toggleTextVoice();
    })
  }), _hoisted_13], 512), [[_vShow, !_ctx.$store.state.textOnlyMode && _ctx.$store.state.brillianceMode]]), _withDirectives(_createElementVNode("div", _hoisted_14, [_hoisted_15, _ctx.$store.state.TutorialPointerMemories ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'brain'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true,
      'ConversationSettings__icon--brain': true
    }),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.toggleMemories();
    })
  }), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'brain'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': false,
      'ConversationSettings__icon--brain': true
    }),
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return _ctx.toggleMemories();
    })
  })])]), _hoisted_18], 512), [[_vShow, !_ctx.$store.state.useMemories && _ctx.$store.state.storeMemories]]), _withDirectives(_createElementVNode("div", _hoisted_19, [_hoisted_20, _ctx.$store.state.TutorialPointerMemories ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'brain'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true,
      'ConversationSettings__icon--brain': true
    }),
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return _ctx.toggleMemories();
    })
  }), _hoisted_21], 512), [[_vShow, _ctx.$store.state.useMemories && _ctx.$store.state.storeMemories]]), _withDirectives(_createElementVNode("div", _hoisted_22, [_hoisted_23, _ctx.$store.state.TutorialPointerMemories ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'brain'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true,
      'ConversationSettings__icon--brain': true
    }),
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return _ctx.toggleMemories();
    })
  }), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'brain'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': false,
      'ConversationSettings__icon--brain': true
    }),
    onClick: _cache[7] || (_cache[7] = function ($event) {
      return _ctx.toggleMemories();
    })
  })])]), _hoisted_26], 512), [[_vShow, _ctx.$store.state.useMemories && !_ctx.$store.state.storeMemories]]), _withDirectives(_createElementVNode("div", _hoisted_27, [_hoisted_28, _ctx.$store.state.TutorialPointerMemories ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'brain'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': false
    }),
    onClick: _cache[8] || (_cache[8] = function ($event) {
      return _ctx.toggleMemories();
    })
  }), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'brain'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': false,
      'ConversationSettings__icon--brain': true
    }),
    onClick: _cache[9] || (_cache[9] = function ($event) {
      return _ctx.toggleMemories();
    })
  })])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createVNode(_component_font_awesome_icon, {
    icon: ['fad', 'brain'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': false,
      'ConversationSettings__icon--brain': true
    }),
    onClick: _cache[10] || (_cache[10] = function ($event) {
      return _ctx.toggleMemories();
    })
  })])]), _hoisted_33], 512), [[_vShow, !_ctx.$store.state.useMemories && !_ctx.$store.state.storeMemories]]), _createElementVNode("div", _hoisted_34, [_hoisted_35, _ctx.$store.state.TutorialPointerContext ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0
  })) : _createCommentVNode("", true), _ctx.$store.state.useContext ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 1,
    icon: ['fad', 'code-branch'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true
    }),
    onClick: _cache[11] || (_cache[11] = function ($event) {
      return _ctx.updateContext();
    })
  })) : _createCommentVNode("", true), !_ctx.$store.state.useContext ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 2,
    icon: ['far', 'circle-small'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true
    }),
    onClick: _cache[12] || (_cache[12] = function ($event) {
      return _ctx.updateContext();
    })
  })) : _createCommentVNode("", true), _createElementVNode("div", {
    "class": _normalizeClass({
      'ConversationSettings__icon-label': true,
      'ConversationSettings__icon-label--inactive': !_ctx.$store.state.useContext
    })
  }, _toDisplayString(_ctx.$store.state.useContext ? 'On' : 'Off'), 3)]), _createElementVNode("div", _hoisted_36, [_hoisted_37, _ctx.$store.state.TutorialPointerResponses ? (_openBlock(), _createBlock(_component_WalkthroughPointer, {
    key: 0
  })) : _createCommentVNode("", true), _ctx.$store.state.simpleResponses ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 1,
    icon: "fa-comment-dots",
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true
    }),
    onClick: _cache[13] || (_cache[13] = function ($event) {
      return _ctx.toggleSimpleResponses();
    })
  })) : _createCommentVNode("", true), !_ctx.$store.state.simpleResponses ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 2,
    icon: "fa-comment",
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true
    }),
    onClick: _cache[14] || (_cache[14] = function ($event) {
      return _ctx.toggleSimpleResponses();
    })
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$store.state.simpleResponses === true || _ctx.$store.state.simpleResponses === 'true' ? 'Minimal' : 'Regular '), 1)]), _createElementVNode("div", {
    "class": "ConversationSettings__icon-holder",
    onClick: _cache[15] || (_cache[15] = function ($event) {
      return _ctx.$store.commit('updateShowAssistantTools', !_ctx.$store.state.showAssistantTools);
    })
  }, [_hoisted_39, _createVNode(_component_font_awesome_icon, {
    icon: ['fa', 'plus'],
    "class": _normalizeClass({
      'ConversationSettings__icon': true,
      'ConversationSettings__icon--active': true,
      'fire': true,
      'fire--active': _ctx.$store.state.showAssistantTools
    })
  }, null, 8, ["class"]), _hoisted_40])])) : _createCommentVNode("", true);
}